var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('simple-header',{attrs:{"title":'Mis Listas',"link":false}}),_c('section',[_c('div',{staticClass:"container-fluid pad"},[_c('mis-listas')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }